<template>
  <div :id="id" class="ui mini modal">
    <h2 class="ui header">{{ title }}</h2>
    <div class="content" v-html="content"></div>
    <div class="actions">
      <button class="ui green button" @click="submit">Yes</button>
      <button class="ui grey button" @click="hideModal">No</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: ['title', 'content', 'id', 'removeDestroyLifecycle'],
  methods: {
    showModal() {
      $(`#${this.id}`).modal({ allowMultiple: true });
      this.showModals(`#${this.id}`);
    },
    hideModal() {
      $(`#${this.id}`).modal('hide');
    },
    submit() {
      this.$emit('actionTaken');
      this.hideModal();
    },
  },
  destroyed() {
    if (!this.removeDestroyLifecycle) {
      $(`#${this.id}`).remove();
    }
  },
};
</script>
